/**
 * Pantalla "No encontramos este recurso" (spec US4/US7): la API responde 404 indistinguible tanto
 * si el recurso no existe como si pertenece a otra empresa o queda fuera del `site_scope`.
 */
import { Link } from '@tanstack/react-router';
import { SearchX } from 'lucide-react';

import { Button } from '../../components/ui/button';
import { EmptyState } from '../../components/ui/empty-state';
import { t } from '../../i18n';

export function NotFound() {
  return (
    <EmptyState
      icon={SearchX}
      title={t('common.notFound.title')}
      description={t('common.notFound.description')}
      action={
        <Button asChild variant="compact">
          <Link to="/">{t('common.notFound.action')}</Link>
        </Button>
      }
    />
  );
}
